<app-menu [moduloEnum]="moduloEnum" [funcionalidadeEnum]="funcionalidadeEnum"></app-menu>

<div class="container">
    <h1 class="title-default">Nova Notificação</h1>

    <form [formGroup]="model" (ngSubmit)="submit()">
        
        <div class="row">
            <div class="col-12">
                <mat-form-field appearance="outline">
                    <mat-label>Título / Assunto</mat-label>
                    <input matInput formControlName="titulo" placeholder="Ex: Aviso de Manutenção" required>
                    @if (model.get('titulo')?.hasError('required')) {
                        <mat-error>O título é obrigatório</mat-error>
                    }
                </mat-form-field>
            </div>
        </div>

        <div class="row align-items-center">
            <div class="col-md-3 mb-3">
                <div class="toggle-container">
                    <mat-slide-toggle color="primary" formControlName="enviarParaTodos" (change)="onChangeEnviarTodos()">
                        Enviar para todas as empresas
                    </mat-slide-toggle>
                </div>
            </div>

            <div class="col-md-9">
                @if(!model.get('enviarParaTodos')?.value){
                    <app-select-pesquisavel
                        label="Selecione as Empresas"
                        [control]="empresasControl"
                        [apiUrl]="_urlListEmpresa"
                        [idField]="'idEmpresa'"
                        [nameField]="'nomeEmpresa'"
                        [multiple]="true"
                        [isOptional]="false">
                    </app-select-pesquisavel>
                } @else {
                    <mat-form-field appearance="outline">
                        <mat-label>Destinatários</mat-label>
                        <input matInput value="Todas as empresas ativas selecionadas" disabled>
                        <mat-icon matSuffix>group</mat-icon>
                    </mat-form-field>
                }
            </div>
        </div>

        <div class="row mt-3">
            <div class="col-12">
                <label class="mb-2 fw-bold" style="color: #666;">Corpo da Mensagem:</label>
                
                <div class="editor-container">
                    <ngx-editor-menu [editor]="editor" [toolbar]="toolbar"></ngx-editor-menu>
                    
                    <ngx-editor [editor]="editor" 
                                formControlName="conteudo" 
                                placeholder="Digite sua mensagem aqui...">
                    </ngx-editor>
                </div>
                
                @if (model.get('conteudo')?.hasError('required') && model.get('conteudo')?.touched) {
                    <mat-error>O conteúdo da mensagem é obrigatório</mat-error>
                }
            </div>
        </div>

        <div class="row">
            <div class="col-12 action-buttons">
                <button type="button" mat-button class="btn-secundary button-big" (click)="cancelar()">
                    Cancelar
                </button>
                
                <button type="submit" mat-flat-button class="btn-primary button-big" [disabled]="model.invalid || _isLoading">
                    @if (_isLoading) {
                        <mat-spinner [diameter]="25" class="mat-spinner-btn"></mat-spinner>
                    } @else {
                        <span class="material-symbols-outlined">send</span> Enviar Notificação
                    }
                </button>
            </div>
        </div>

    </form>
</div>